import { initializeClient } from './client.init';

/**
 * Initializes the application, handling any execution
 * context-specific setup.
 * @returns {void}
 */
export const initializeApp = async (): Promise<void> => initializeClient();
